import Carousel from '@brainhubeu/react-carousel';
import '@brainhubeu/react-carousel/lib/style.css';
import Node from '@types/node';
import classNames from 'classnames/bind';
import React, { FunctionComponent, useEffect } from 'react';

import { ControlsSizeType, ThemeVariantType } from '../../typings';
import Section from '../section/section';
import styles from './carousel.module.scss';
import { CarouselImage } from './carusel-image-slider/carusel-image-slider';
import ArrowLeft from '../../assets/images/slide-left.inline.svg';
import ArrowRight from '../../assets/images/slide-right.inline.svg';

const cx = classNames.bind(styles);

export interface ICarouselProps {
  imageCollection?: string[];
  itemsCollection?: IKontentItem[];
  headline?: string;
  themeVariant: ThemeVariantType;
  withArrow?: boolean;
  enableDots?: boolean;
  allowAutoplay?: boolean;
  slidesPerPage?: number;
  slidesPerPageMobile?: number;
  border: boolean;
  controlsSize: ControlsSizeType;
  id?: string;
}

const defaultArrowSettings = {
  arrows: true,
  arrowLeft: (
    <div className={`${styles.arrow} ${styles.arrowPrev}`}>
      <ArrowLeft className={styles.arrowIcon} />
    </div>
  ),
  arrowRight: (
    <div className={`${styles.arrow} ${styles.arrowNext}`}>
      <ArrowRight className={styles.arrowIcon} />
    </div>
  ),
  addArrowClickHandler: true,
  stopAutoPlayOnHover: true,
  slidesPerPage: 5
};
const loadCarouselComponent = (): Node.require => {
  return typeof window !== `undefined`
    ? require('@brainhubeu/react-carousel')
    : null;
};
const arrowSettings = (withArrow: boolean | undefined): ICarouselProps | null =>
  withArrow ? defaultArrowSettings : null;
const defaultAutoPlay = (
  allowAutoplay: boolean | undefined
): { autoPlay: number } | null => (allowAutoplay ? { autoPlay: 5000 } : null);

export const CarouselComponent: FunctionComponent<ICarouselProps> = props => {
  const {
    imageCollection,
    itemsCollection,
    headline,
    themeVariant,
    withArrow,
    allowAutoplay,
    slidesPerPage,
    slidesPerPageMobile,
    enableDots,
    border,
    controlsSize,
    id
  } = props;
  useEffect(() => {
    loadCarouselComponent();
  }, []);

  return (
    <section
      data-theme={`theme-${themeVariant}`}
      className={cx({ border, largeControls: controlsSize === 'large' })}
      id={id}
    >
      <div className={styles.componentWrapper}>
        <div className={styles.container}>
          {headline && (
            <div
              dangerouslySetInnerHTML={{ __html: headline }}
              className={styles.headline}
            />
          )}
          <div
            className={`${styles.carouselSection} ${
              !withArrow || slidesPerPage < 4
                ? styles.carouselSectionWithoutArrows
                : ''
            }`}
          >
            <Carousel
              {...defaultAutoPlay(allowAutoplay)}
              {...arrowSettings(withArrow)}
              slidesPerPage={slidesPerPage}
              animationSpeed={1000}
              infinite
              dots={enableDots}
              breakpoints={{
                768: {
                  slidesPerPage: slidesPerPageMobile
                    ? slidesPerPageMobile
                    : slidesPerPage
                }
              }}
            >
              {imageCollection
                ? imageCollection.map((image, k) => (
                    <CarouselImage src={image} key={k} />
                  ))
                : itemsCollection
                ? itemsCollection.map((item, i) => (
                    <Section linkedItem={item} key={i} />
                  ))
                : null}
            </Carousel>
          </div>
        </div>
      </div>
    </section>
  );
};
